import styled from '@emotion/styled';
import securityWall from '../images/security-wall.svg';
import totpChallenge from '../images/two-step-verification/mfa-enable.png';
import { media } from '../utilities/style-utils';
import { gridSize } from '@atlaskit/theme';
import React, { useMemo } from 'react';

type SecurityWallStyle = 'default' | 'password-reset' | 'totp';

const DefaultSecurityWallContainer = styled.div`
  background: url(${securityWall}) no-repeat center 0 / ${gridSize() * 14.5}px;
  min-width: 100%;
  margin-top: ${gridSize()}px;
  padding-top: ${gridSize() * 18}px;
  box-sizing: border-box;

  ${media.handheld`
    background: 0;
    padding: 0;
  `}
`;

const TotpChallengeContainer = styled.div`
  background: url(${totpChallenge}) no-repeat center 0 / ${gridSize() * 30}px;
  min-width: 100%;
  margin-top: ${gridSize()}px;
  padding-top: ${gridSize() * 18}px;
  box-sizing: border-box;

  ${media.handheld`
    background: none;
    padding: 0;
  `}
`;

const SuccessfulResetSecurityWallContainer = styled.div`
  background: url(${securityWall}) no-repeat center;
  height: ${gridSize() * 14.5}px;
  margin-top: ${gridSize() * 1}px;
  margin-bottom: ${gridSize() * 1.5}px;
`;

interface Props {
  children?: React.ReactNode;
  id?: string;
  securityWallStyle?: SecurityWallStyle;
}

export const SecurityWall = ({ children, id, securityWallStyle }: Props) => {
  const WallComponent = useMemo(() => {
    switch (securityWallStyle) {
      case 'password-reset':
        return SuccessfulResetSecurityWallContainer;
      case 'totp':
        return TotpChallengeContainer;
      default:
        return DefaultSecurityWallContainer;
    }
  }, [securityWallStyle]);

  return <WallComponent id={id}>{children}</WallComponent>;
};
